import React from 'react';
import { CacheProvider } from '@emotion/react';
import { emotionCache } from './emotion-cache';
import SiteCore from './src/templates/SiteCore';

export const wrapPageElement = ({ element, props }) => {
    if (props.location.pathname.startsWith('/secure/')) {
        return element;
    }
    return (
        <CacheProvider value={emotionCache}>
            <SiteCore {...props}>{element}</SiteCore>
        </CacheProvider>
    );
};